import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { OfferingEnvironment } from '../../../models/offering';
import { TeaserCardComponent } from '../../shared/teaser-card/teaser-card.component';

@Component({
  selector: 'inexp-offering-environments',
  imports: [TeaserCardComponent],
  templateUrl: './offering-environments.component.html',
  styleUrl: './offering-environments.component.scss',
})
export class OfferingEnvironmentsComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  router = inject(Router);
  environments = input<OfferingEnvironment[]>();
}
